import type { TourStep } from '../types';
export const designerThemeUploadSteps: TourStep[] = [
  { target: '[data-tour="designer-theme-source"]', title: 'Исходные материалы', content: 'Скачайте доступные материалы для подготовки макетов.' },
  { target: '[data-tour="designer-theme-plan-upload"]', title: 'План загрузки', content: 'Сверьте количество файлов с планом задания.' },
  { target: '[data-tour="designer-theme-upload-btn"]', title: 'Загрузить макеты', content: 'Добавьте готовые PDF-файлы на проверку.' },
  { target: '[data-tour="designer-theme-uploaded"]', title: 'Загруженные файлы', content: 'Проверьте список и статус уже отправленных макетов.' },
];
